<template>
    <li v-if="message.user" :class="(message.to_speaker?'message-to-speaker':'')+' p-1 border rounded '" :style="'background:'+client_settings.messages_background+';border-color:'+client_settings.messages_border_color" :title="message.status">
      <div class="row p-0 m-0">
        <div class="col-11">
          <div class="question-badge" v-if="message.to_speaker"><b-icon-question class="question-icon"></b-icon-question></div>
          <span class="message-datetime text-muted mr-2">{{ message.created }}</span>
          <span>
                <span v-for="role in message.user.roles" :key="'role'+role.id" :class="'username role-'+role.name" :title="role.name">
                    <b-icon-person v-if="role.name==='audience'"></b-icon-person>
                    <b-icon-person-check v-if="role.name==='speaker'"></b-icon-person-check>
                    <b-icon-emoji-sunglasses v-if="role.name==='moderator'"></b-icon-emoji-sunglasses>
                    <b-icon-emoji-sunglasses v-if="role.name==='admin'"></b-icon-emoji-sunglasses>
                </span>
           </span>

          <strong v-if="message.user.id !== user.id" :class="'username role-'+message.user.roles[0].name" style="position: relative;" @click.prevent="PMReady?$emit('send-pm-user', message.user):null">
<!--            {{ message.user.name }}-->
              {{message.user.name==='Аноним'?text_lang[room_language]['text_anon']:message.user.name}}
          </strong>
          <strong v-else :class="'username'" :style="'position: relative;color:'+message.user.roles[0].color">
              {{message.user.name==='Аноним'?text_lang[room_language]['text_anon']:message.user.name}}
          </strong>

          <span v-if="message.reply_to">
                                    {{ text_lang[room_language]["text_message_to"]}}
                                    <strong :class="'username role-'+message.reply.user.roles[0].name">
<!--                                        {{message.reply.user.name}}-->
                                        {{message.reply.user.name==='Аноним'?text_lang[room_language]['text_anon']:message.reply.user.name}}
                                    </strong>
                                </span>
          :

          <div class="reply-to" v-if="message.reply_to">
            {{message.reply.user.name}} <span class="text-muted mr-2">{{ message.reply.created }}</span><br>
            {{message.reply.message}}
          </div>

          <div class="message-text" v-linkified :style="(message.status==='deleted'?'text-decoration: line-through;':'')+';color:'+client_settings.messages_text_color">{{ message.message }}</div>
        </div>
        <div class="col-1 p-0 text-right">
          <b-button @click="$emit('send-set-reply', message)" :style="'color:'+client_settings.buttons_color" variant="link" size="sm" class="m-0 p-0" title="Reply">
            <b-icon-reply></b-icon-reply>
          </b-button>
        </div>
      </div>
    </li>
</template>

<script>
// import ContextMenu from "./ContextMenu/ContextMenu";
// import ContextMenuItem from "./ContextMenu/ContextMenuItem";
// import { VueContext } from 'vue-context';

export default {
    name: 'OneMessage',
    components: {
        // ContextMenu,
        // ContextMenuItem,
        // VueContext,
    },
    props: {
        message: {},
        index: null,
        user: null,
        reply_message: null,
        PMReady: null,
        client_settings: {},
        text_lang: {},
        room_language: null,
    },
    methods: {
        rightMenuOpen(index, event) {
            console.log(event);
            this.$refs.menu.open(event, '');
        },
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
